import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { updateAsset } from '../../../redux/actions/manageAssetActions';
import { useDispatch } from 'react-redux';
import { isEmpty } from 'lodash';

const alignmentMap = {
	empty: '',
	vertical: 'vertical',
	horizontal: 'horizontal',
	organic_horizontal: 'organic_horizontal',
	any: 'any',
};

const useStyles = makeStyles((theme) => ({
	formControl: {
		margin: theme.spacing(1),
	},
	alignmentSelect: {
		minWidth: 170,
	},
	selectEmpty: {
		marginTop: theme.spacing(2),
	},
}));

export default function AlignmentSelect({ asset }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const alignment = asset?.alignment;
	const [state, setState] = React.useState(alignment);
	const handleChange = (event) => {
		const name = event.target.value;
		setState(name);
		let updatedAsset = {};
		if (isEmpty(name)) {
			// when empty option is selected in the dropdown. remove alignment field from meta data object, to set the alignment empty in backend.
			delete asset.alignment;
			asset.metadata = {};
			updatedAsset = asset;
		} else {
			const metadata = {
				alignment: name,
			};
			updatedAsset = { ...asset, metadata: { ...metadata } };
		}
		dispatch(updateAsset(updatedAsset));
	};
	const alignmentKeys = Object.keys(alignmentMap);
	return (
		<div>
			<FormControl variant="outlined" className={classes.formControl}>
				<InputLabel htmlFor="outlined-alignment-simple"> Alignment </InputLabel>{' '}
				<Select
					native
					value={state}
					onChange={handleChange}
					label="alignment"
					className={classes.alignmentSelect}
					inputProps={{
						name: 'alignment',
						id: 'alignment-select',
					}}
				>
					{alignmentKeys.map((key) => {
						const alignment = alignmentMap[key];
						return (
							<option value={alignment} key={alignment}>
								{alignment}
							</option>
						);
					})}
				</Select>
			</FormControl>
		</div>
	);
}
